// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1V_NF","select":"styles_select__2ldz3"};